"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseModelSyntaxNodes = parseModelSyntaxNodes;
const pi_syntax_tools_1 = require("@icg360/pi-syntax-tools");
const immer_1 = require("immer");
const walker_1 = require("./walker");
function parseModelSyntaxNodes(formModel, errorCallback) {
    return (0, immer_1.produce)(formModel, draft => mutateFormModel(draft, errorCallback));
}
function mutateFormModel(model, errorCallback) {
    const walker = new walker_1.FormModelWalker();
    const cb = errorCallback
        ? (error, property = "") => errorCallback(error, walker.path + property)
        : undefined;
    if (model.key) {
        model.key = parseSyntaxInNode(model.key, ".key", cb);
    }
    for (const node of walker.start(model)) {
        if (node.type === "term") {
            if (node.key) {
                node.key = parseSyntaxInNode(node.key, ".key", cb);
            }
            if (node.label) {
                node.label = parseTextOrSyntax(node.label, ".label", cb);
            }
            if (node.calculate) {
                node.calculate = parseSyntaxInNode(node.calculate, ".calculate", cb);
            }
            if (node.enumsFn) {
                node.enumsFn = parseSyntaxInNode(node.enumsFn, ".enumsFn", cb);
            }
            if (node.relevant) {
                node.relevant = parseSyntaxInNode(node.relevant, ".relevant", cb);
            }
            if (node.required) {
                node.required = parseSyntaxInNode(node.required, ".required", cb);
            }
            if (node.readonly) {
                node.readonly = parseSyntaxInNode(node.readonly, ".readonly", cb);
            }
        }
        else if (node.type === "iterable") {
            node.count = parseSyntaxInNode(node.count, ".count", cb);
            if (node.key) {
                node.key = parseSyntaxInNode(node.key, ".key", cb);
            }
        }
        else if (node.type === "term-enum") {
            if (node.relevant) {
                node.relevant = parseSyntaxInNode(node.relevant, ".relevant", cb);
            }
        }
        else if (node.type === "term-event-suppose" ||
            node.type === "term-event-when") {
            node.condition = parseSyntaxInNode(node.condition, ".element", cb);
        }
        else if (node.type === "term-event-set") {
            node.value = parseTextOrSyntax(node.value, ".element", cb);
        }
        else if (node.type === "term-validation") {
            if (node.min) {
                node.min = parseTextOrSyntax(node.min, ".min", cb);
            }
            if (node.max) {
                node.max = parseTextOrSyntax(node.max, ".max", cb);
            }
        }
    }
    model.process.syntax = true;
}
function parseTextOrSyntax(textOrSyntax, property, errorCallback) {
    if (textOrSyntax.type === "text") {
        return textOrSyntax;
    }
    return parseSyntaxInNode(textOrSyntax, property, errorCallback);
}
function parseSyntaxInNode(syntax, property, errorCallback) {
    if (syntax.type === "syntax-tree") {
        return syntax;
    }
    try {
        const tree = (0, pi_syntax_tools_1.parseSyntax)(syntax.value);
        if (!tree) {
            const error = new Error("Syntax is incomplete");
            if (errorCallback) {
                errorCallback(error, property);
                return syntax;
            }
            else {
                throw error;
            }
        }
        return {
            type: "syntax-tree",
            tree,
        };
    }
    catch (error) {
        if (!errorCallback) {
            throw error;
        }
        if (error instanceof Error) {
            errorCallback(error, property);
        }
        return syntax;
    }
}
//# sourceMappingURL=parse-syntax-nodes.js.map